import React from 'react';
import Span from '../../Texts/Span/Span';
import * as S from './DescriptionFormatter.styles';

export const DescriptionFormatter = ({ cell, formatExtraData }) =>
  cell ? (
    <S.Description overflowHidden={formatExtraData?.overflowHidden}>
      <Span variant='neutral' modifier='strong' type='4'>
        {cell}
      </Span>
    </S.Description>
  ) : null;
